'use client';

import React from "react";

const brandTexts = [
  "Librium Tech",
  "Enumium",
  "iVipp",
  "DOLR",
  "NUAIRS",
  "Crypto Cash",
  "HBCU League Pass",
  "Representing ME",
  "The Real Flow",
  "U-Be-Secure",
  "BlueMoose TV",
];

function Brands() {
  const renderTexts = (size, repeatCount) => {
    // Repeat the array to create the desired number of elements
    const textsArray = Array(repeatCount).fill(brandTexts).flat();

    return textsArray.map((text, index) => (
      <div
        key={index}
        className={`cursor-pointer flex-shrink-0 text-center text-2xl font-semibold text-color-2 px-4 py-2 rounded-lg transition-all`}
      >
        {text}
      </div>
    ));
  };

  return (
    <div className="pb-16 relative">
      <div className="absolute bottom-0 h-72 w-full bg-gradient-to-b from-transparent via-color-99 to-color-99 pointer-events-none"></div>
      <p className="z-30 relative text-transparent text-center text-xl sm:text-[30.1px] tracking-[0] leading-[normal] font-bold text-[#a8a8a8]">
        <span className="text-color-2">Trusted By </span>
        <span className="text-color-1">Leading Brands</span>
        <span className="text-color-2"> Worldwide</span>
      </p>

      <div className="relative overflow-hidden">
        <div className="[background:linear-gradient(to_right,_var(--primary-bg)_0%,_transparent_10%,_transparent_90%,_var(--primary-bg)_100%)] absolute z-10 inset-0 pointer-events-none"></div>
        {/* Desktop Marquee */}
        <div
          id="marquee"
          className="hidden md:flex gap-16 items-center justify-start w-full mt-10 animate-marquee"
        >
          {renderTexts("w-[170px]", 3)} {/* Repeat logos 4 times */}
        </div>

        {/* Mobile Marquee */}
        <div className="mt-10 md:hidden">
          <div
            id="marquee"
            className="flex gap-6 items-center justify-start w-[150%] animate-marquee"
          >
            {renderTexts("w-[120px]", 2)} {/* Repeat logos 2 times */}
          </div>
          <div
            id="marquee"
            className="flex gap-6 items-center justify-start w-[150%] animate-marquee animate-marquee-rev"
          >
            {renderTexts("w-[120px]", 2)} {/* Repeat logos 2 times */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Brands;
